var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.57143C14 8.88944 14.2739 8.23539 14.7615 7.75315C15.2491 7.27092 15.9104 7 16.6 7H24.4C25.0896 7 25.7509 7.27092 26.2385 7.75315C26.7261 8.23539 27 8.88944 27 9.57143V22.4286C27 23.1106 26.7261 23.7646 26.2385 24.2468C25.7509 24.7291 25.0896 25 24.4 25H16.6C15.9104 25 15.2491 24.7291 14.7615 24.2468C14.2739 23.7646 14 23.1106 14 22.4286V9.57143Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10V22",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11V21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideosIcon);
export default __webpack_public_path__ + "static/media/videosIcon.cac0e300299e5c7a44de0daaa7ba403b.svg";
export { ForwardRef as ReactComponent };